import _ from 'lodash';
import Promise from 'bluebird';
import getHelpers from '../helpers';
const api = getHelpers('api');

// initial state
const state = {
    ...window.store,
    timestamp: Date.now(),
}

// getters
const getters = {
    resident: (state) => state.resident,
    timestamp: (state) => state.timestamp,
    route: (state) => (name, params) => {
        let path = '/' + _.get(state, ['routes', name]);

        _.forEach(params, (value, key) => {
            path = _.replace(path, new RegExp(`{${key}[?]?}`), value);
        })

        return path;
    }
}

const actions = {
    addFavouriteResident({ commit }, data) {
        return api.postData('/my/favourite_resident_entries', {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Resident has been added to favourite list',
                });
                commit('addFavouriteResident', res);
                return res;
            })
    },

    removeFavouriteResident({ commit }, payload) {
        const { id } = payload;

        return api.delData(`/my/favourite_resident_entry/${id}`, {})
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Resident has been removed from favourite list',
                });
                commit('removeFavouriteResident', res);
                return res;
            })
    },
}

// mutations
const mutations = {

    addNotification(state, payload) {
        _.set(state, 'notifications', _.concat(state.notifications, [payload]));
    },
    addFavouriteResident(state, response) {
        let data = _.get(state, 'resident.included.favourite_resident_entries.data', []);
        data = _.concat(data, response);

        _.set(state, 'resident.included.favourite_resident_entries.data', data);
        _.set(state, 'timestamp', Date.now());
    },

    removeFavouriteResident(state, response) {
        let data = _.get(state, 'resident.included.favourite_resident_entries.data', []);
        data = _.filter(data, (item => item.id != response.id));

        _.set(state, 'resident.included.favourite_resident_entries.data', data);
        _.set(state, 'timestamp', Date.now());
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
